import React from 'react';

import './button.style.css';

const Button = ({
  children,
  disabled,
  icon,
  ...otherProps
}) => (
  <button
    className={`custom-button ${disabled ? 'disabled' : ''}`}
    disabled={disabled}
    {...otherProps}
  >
    { children}
  </button >
);

export default Button;
